jQuery(document).ready(function ($) {
    const more_btn = $('.archive [data-post-hide-more]');
    const wrapper = $('.archive [data-post-wrapper]');
    if (!more_btn.length || !wrapper.length) return;
    const post_type = more_btn.attr('data-post-type');
    const tax_name = more_btn.attr('data-tax-name') ?? '';
    const term_slug = more_btn.attr('data-term-slug') ?? '';
    if (!post_type) return;
    const limit = Number(more_btn.attr('data-page-limit') || 10);
    const max_pages = Number(more_btn.attr('data-max-pages') || 1);
    let page = Number(more_btn.attr('data-paged') || 1);

    getPosts();

    $(more_btn).on('click', getPosts);

    function getPosts() {
        more_btn.addClass('loading');

        $.ajax({
            url: '/wp-admin/admin-ajax.php',
            type: 'POST',
            data: {
                action: 'get_archive_posts',
                post_type,
                tax_name,
                term_slug,
                limit,
                page
            },
            success: (result) => {
                wrapper.append(result);

                if (page >= max_pages) {
                    more_btn.hide();
                }

                page += 1;
            },
            complete: () => {
                more_btn.removeClass('loading');
            },
            error: (error) => console.error(error)
        });
    }
});
